import { CREATE_SPECIAL_OFFERS_FAILURE, CREATE_SPECIAL_OFFERS_REQUEST, GET_ALL_OFFERS_FAILURE, GET_ALL_OFFERS_REQUEST, GET_ALL_OFFERS_SUCCESS, GET_OFFERS_BY_VENDOR_FAILURE, GET_OFFERS_BY_VENDOR_REQUEST, GET_OFFERS_BY_VENDOR_SUCCESS, GET_OFFERS_FAILURE, GET_OFFERS_REQUEST, GET_OFFERS_SUCCESS, GET_SPECIAL_OFFERS_FAILURE, GET_SPECIAL_OFFERS_REQUEST, GET_SPECIAL_OFFERS_SUCCESS } from "./ActionType";


const initialState = {
    loading: false,
    offers: [],
    specialOffers: [],
    error: "",
}

const adminOfferReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_OFFERS_REQUEST:
        case GET_ALL_OFFERS_REQUEST:
        case CREATE_SPECIAL_OFFERS_REQUEST:
        case GET_SPECIAL_OFFERS_REQUEST:
        case GET_OFFERS_BY_VENDOR_REQUEST:
            return { ...state, loading: true };

        case GET_OFFERS_SUCCESS:
        case GET_ALL_OFFERS_SUCCESS:
        case GET_OFFERS_BY_VENDOR_SUCCESS:
            return { ...state, loading: false, offers: action.payload, error: "" };

        case GET_SPECIAL_OFFERS_SUCCESS:
            return { ...state, loading: false, specialOffers: action.payload, error: "" };


        case GET_OFFERS_FAILURE:
        case GET_ALL_OFFERS_FAILURE:
        case CREATE_SPECIAL_OFFERS_FAILURE:
        case GET_SPECIAL_OFFERS_FAILURE:
        case GET_OFFERS_BY_VENDOR_FAILURE:
            return { ...state, loading: false, offers: [], specialOffers: [], error: action.payload };

        default:
            return state;
    }
}
export default adminOfferReducer